export enum TipoServizio {
  Credito = 0,
  Abbonamento,
  CreditiTempo,
  StandAlone
}

export class ServizioPerImpianto {
  ServizioId: number;
  NomeServizio: string;
  Blocco: number;
  BloccoCartaVIP: number;
  Attivo: boolean;
  Prezzo: number;
  IsAcquistato: boolean;
  TipoServizio: TipoServizio;
  Borsellino: Borsellino | null;
}

export class ServizioPerListino {
  ListinoId: number;
  Nome: string
  Prezzo: number;
  ServizioPerImpiantoImpiantoId: number;
  ServizioPerImpiantoServizioId: number;
}

export class ServizioPerListinoRicaricaCarta {
  ServizioPerImpiantoServizioId: number;
  Prezzo: number
}

export class Servizio {
  Id: number;
  NomeInterno: string;
  NomePubblico: string;
  Blocco: number;

}

export class ServizioImpiantoPerStatistica {
  ServizioId: number;
  CreditiRicaricati: number;
}

export enum Borsellino{
  A = 1,
  B = 2
}


// WEBPACK FOOTER //
// ./src/app/models/servizio.ts